/**
 * Anonymous visitor session id — stored in localStorage.
 * Used as X-Session-Id header for uploads and as `?s=` param for iframe downloads.
 */
const KEY = "kyp_session_id";

function makeId() {
  // 24-char URL-safe id
  const bytes = new Uint8Array(18);
  (window.crypto || window.msCrypto).getRandomValues(bytes);
  return btoa(String.fromCharCode(...bytes))
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/, "");
}

export function getSessionId() {
  let id = null;
  try {
    id = localStorage.getItem(KEY);
  } catch (e) {
    // localStorage blocked — fall back to in-memory
  }
  if (!id) {
    id = makeId();
    try {
      localStorage.setItem(KEY, id);
    } catch (e) {
      // ignore
    }
  }
  return id;
}

export function resetSessionId() {
  try {
    localStorage.removeItem(KEY);
  } catch (e) {}
}
